// in case not included in product page, replaced by v2
if (document.querySelector('#product')) {
    /************
     Product Swiper
     ************/

// setup product swiper
    let productImages = new Swiper("#productSwiper");

// thumbnail
    document.querySelectorAll(".productThumbnail").forEach(function (element) {
        element.addEventListener("click", function () {
            // determine index
            let index = getElIndex(this);

            // change active slide
            productImages.slideTo(index);
        });
    });

    /*******************
     Product Subscription
     ********************/
    let subscription = true;
// check for subscription exemption
    document.querySelector('#productCheckout').classList.contains('noSub') ? subscription = false : null;

    let subscriptionID = document.querySelector('#productAddSubSelect')?.value;

// if one-time is selected subscription is false
    document.querySelectorAll('.productAddSubItem').forEach(el => {
        el.addEventListener('click', function () {
            if (this.classList.contains('subscribe')) {
                this.parentElement.classList.add('active');
                subscription = true;
            } else {
                this.parentElement.classList.remove('active');
                subscription = false;
            }
            updatePricingPerBottle();
        })
    })

// update the price per bottle and serving as compared to subscription price
    function updatePricingPerBottle() {
        document.querySelectorAll('.productVariantSideStack').forEach(el => {
            subscription === true ? el.classList.add('active') : el.classList.remove('active');
        })
        const activeInput = document.querySelector('.productVariant.active input');
        let oTPSavings = "";
        if (activeInput.dataset.quantity === "3") {
            oTPSavings = " - 5% Off"
        } else if (activeInput.dataset.quantity === "5") {
            oTPSavings = " - 12% Off"
        }
        if (subscription) {
            productATC.innerHTML = `Subscribe & Save - ${activeInput.dataset.saved}% Off 🛒`;
        } else {
            productATC.innerHTML = `Add to Cart${oTPSavings} 🛒`;
        }
    }

// initial pricing
    updatePricingPerBottle();

// keep track of current plan id
    document.querySelector('#productAddSubSelect')?.addEventListener('change', function () {
        subscriptionID = this.value;
    })

    /**************
     Product FAQ
     ***************/

    document.querySelectorAll('.productFaqQuestion').forEach((el) => {
        el.addEventListener('click', function () {
            this.parentNode.classList.toggle('active');
        })
    })

    /**************
     Product Variants
     ***************/

// initial variant
    let variantInput = document.querySelector('.productVariant.active');
// update active variant on input changes
    document.querySelectorAll(".productVariant").forEach(function (element) {
        element.addEventListener("change", function () {
            // change active variant label
            document.querySelector('.productVariant.active').classList.remove('active');
            this.classList.add('active');

            // get input
            variantInput = this.querySelector('.productVariantID');

            // update atc drop shadow
            document.querySelector('#productATC').setAttribute("position", variantInput.dataset.position);

            // update quantity
            quantity = parseInt(variantInput.dataset.quantity);

            // get variant id
            let activeVariantID = variantInput.dataset.id;

            // update savings amount
            document.querySelectorAll('.productAddSubInfoItemSavings').forEach(el => {
                el.classList.remove('active');
                if (el.dataset.id === activeVariantID) el.classList.add('active');
            })

            // update text on ATC button
            updatePricingPerBottle();
        });
    })

    /****************
     * Product Quantity
     ******************/

    let quantity = parseInt(variantInput.querySelector('.productVariantID').dataset.quantity);

    /**************
     Product ATC
     ***************/

    document.querySelector("#productATC").addEventListener("click", async function () {
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
                // if subscription is chosen, use active id
                selling_plan: subscription ? subscriptionID : null
            }]
        };

        // add product
        await addProduct(formData);

        // open cart
        await openCart();

        this.classList.remove("loading");
    });

    /**************
     Product Upsell
     ***************/

    document.querySelectorAll(".productUpsellButtonAdd").forEach(el => {
        el.addEventListener('click', async function (e) {
            // button wrapped in anchor tag
            e.preventDefault();

            // if ATC button is subscribe
            let sellingPlan = this.classList.contains('subscribe');
            let id = this.parentElement.dataset.id;
            let subscription = this.parentElement.dataset.subscribe;

            this.classList.add("loading");

            let formData = {
                items: [{
                    quantity: 1,
                    id: id,
                    // if subscription is chosen, use active id
                    selling_plan: sellingPlan ? subscription : null
                }]
            };

            // add product
            await addProduct(formData);

            // open cart
            await openCart();

            this.classList.remove("loading");

        })
    })
}